import React from "react";
import { Button } from "@design-system/Button/Button";
import { CommandIsland } from "@design-system/CommandIsland/CommandIsland";
import { Menu } from "@design-system/Menu/Menu.lib";
import { CounterpartyDirectoryViewRow } from "./counterpartyDirectoryViewTypes";
import { useCounterpartyRecordOpeners } from "./useCounterpartyRecordOpeners";
import styles from "./CounterpartyDetailsPanel.module.scss";

interface Props {
    row: CounterpartyDirectoryViewRow;
    showEdit: boolean;
    onEdit: () => void;
}

export const CounterpartyDetailsCommandBar: React.FC<Props> = ({
    row,
    showEdit,
    onEdit,
}) => {
    const counterpartyId = row.counterparty?.id ?? "";
    const { openJournalEntries, openTransactions, openInvoices, openBills } =
        useCounterpartyRecordOpeners(counterpartyId);

    return (
        <CommandIsland className={styles.actions} sticky>
            <div>
                {showEdit && (
                    <Button variant="primary" size="md" onClick={onEdit}>
                        Edit
                    </Button>
                )}
            </div>
            {counterpartyId && (
                <Menu.More aria-label="View related records">
                    <Menu.Item
                        onClick={openJournalEntries}
                        disabled={(row.journalEntryLinesCount ?? 0) === 0}
                    >
                        View journal entries
                    </Menu.Item>
                    <Menu.Item onClick={openTransactions}>
                        View transactions
                    </Menu.Item>
                    <Menu.Item
                        onClick={openInvoices}
                        disabled={(row.invoiceCount ?? 0) === 0}
                    >
                        View invoices
                    </Menu.Item>
                    <Menu.Item
                        onClick={openBills}
                        disabled={(row.billCount ?? 0) === 0}
                    >
                        View bills
                    </Menu.Item>
                </Menu.More>
            )}
        </CommandIsland>
    );
};
